module.exports = function() {
  return new Worker(__webpack_public_path__ + "11bcbb8c19968e73dd3a.worker.js");
};